import React from 'react';
import JobDetails from '../../../shared/components/JobDetails';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import JobApplyButton from './JobApplyButton';
import ATSApply from './ATSApply';
import Alert from '@material-ui/lab/Alert';

export default function JobSingle(props) {
  return (
    <Grid container>
      <Grid item xs={1}>
        <IconButton edge="start" color="inherit" aria-label="back" onClick={props.JobBackClick}>
          <ArrowBackIosIcon />
        </IconButton>
      </Grid>
      <Grid item xs={11}>
        <Grid container>
          <Grid item sm={12} md={7}>
            <JobDetails job={props.currentJob} />
          </Grid>
          <Grid item sm={12} md={5}>
          { props.jobApplies[props.currentJob.id] ?
           <Alert severity="success">You have applied to this job.</Alert> :
           ( (props.currentJob.ats_url && props.currentJob.ats_url.length > 4) ? <ATSApply job={props.currentJob} /> : <JobApplyButton onClick={props.submitJobApply} applyInProgress={props.jobApplyInProgress}  /> )
          }
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
